/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form, Formik, Field } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import { differenceInCalendarDays, isAfter } from 'date-fns';
import Layout from 'components/Layout';
import Colors from 'constants/Colors';
import { ButtonContent } from './styles';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import StepNavigation from 'components/StepNavigation';
import BrokingSummary from 'components/BrokingSummary';
import {
	Button,
	ButtonContainer,
	LostCancelButton,
	FormContainer,
	FormSectionGlobal as FormSection,
	Clauses,
	ResponsiveTable,
	FileModal,
	NotesAccordion,
	HasPermission
} from '@fitinsur/components'
import { Content } from './styles';
import * as yup from 'yup';
import { CheckBox, Label } from "@fitinsur/components";
import { useGetDocuments } from 'services/DocumentsService';
import {
	LoaderContext
} from '@fitinsur/contexts'
import { useGetOperationAsync, useResetOperationState, useUpdateOperationSync } from 'services/OperationService';
import { useGetQuestionnaireAnswer, useSaveQuestionnaireAnswer } from 'services/QuestionnaireAnswerService';
import {
	useUpdateDocumentsClausesSync
} from 'services/ClausesService';
import { onValidationError } from 'containers/edit/handleQuestionChange';
import {
	handleQuestionsInitialAdjustments,
	groupConvertToSimpleData,
	getSelectedPartners,
} from './handleQuestionChange';
import { cloneDeep, isEmpty } from 'lodash';
import { useSendCCGASync } from 'services/QuoteService';
import { useSendStamp } from 'services/StampService';
import {
	useGetReportData
} from '@fitinsur/services/ReportService';
import { useGetPersonRole } from 'services/PersonRoleService';
import {
	useSavePersonRelationships
} from '@fitinsur/services/PersonRelationshipsService';

const useManualSignature = true;
const useSendStampRequestMessage = `Prezado(s),

Você está recebendo este link para assinatura do Contrato de Contragarantia por ser indicado como representante legal ou fiador nesta contratação, e em conformidade com as disposições de seu Estatuto e/ou Contrato Social ou ainda relação societária.

Atenciosamente,
SOMPO SEGUROS`;

export default function CCGClauses({ permissions, ...props }) {
	const authContext = useContext(GlobalAuthContext);
	const [partners, setPartners] = useState([]);
	const { updateIsLoadingStatus } = useContext(LoaderContext);
	const validationSchema = useRef(yup.object().shape({}));
	const history = useHistory();
	const mc = new MessageCenter();
	const formikRef = useRef({});
	const [operation, setOperation] = useState({});
	const [isBound, setIsBound] = useState(true);
	const handleBack = () => history.goBack();
	const [selectedClauses, setSelectedClauses] = useState([]);
	const [clausesLoading, setClausesLoading] = useState(false);
	const [questionnaire, setQuestionnaire] = useState([]);
	const [documents, setDocuments] = useState([]);
	const [idProductPlan, setIdProductPlan] = useState(0);
	const recalculateParameters = useRef([])
	const [reportData, setReportData] = useState(null);
	const [signers, setSigners] = useState([]);
	const [enableButton, setEnableButton] = useState(false);
	const [certifiedDeliveries, setCertifiedDeliveries] = useState([]);
	const [borrowerName, setBorrowerName] = useState('');

	const columnsPartners = [
		{
			title: "Seleção",
			key: "selected",
			minWidth: 5,
			maxWidth: 10,
			component: (row) => <CheckBox
				checked={partners.find(p => p.documentId === row.documentId)?.selected}
				onClick={() => {
					setPartners((previous) => previous.map(ptnr => {
						if (ptnr.documentId === row.documentId) {
							ptnr.selected = !row.selected;
						}
						return ptnr;
					}));
				}}
			/>

		},
		{
			title: "CPF/CNPJ",
			key: "documentId",
			minWidth: 10,
			maxWidth: 20,
		},
		{
			title: "Nome Completo/Razão Social",
			key: "name",
			minWidth: 10,
			maxWidth: 40,
			notLastColumnAlign: true,
		}
	];

	const SECTIONS = {
		CCG_DATA: { name: 'CCG_DATA', isMultiple: false, isRisk: false }
	};

	const {
		data: useGetDocumentsData,
		loading: useGetDocumentsLoading,
		error: useGetDocumentsError,
		status: useGetDocumentsStatus,
		request: useGetDocumentsRequest
	} = useGetDocuments(props.match.params.idOperation);

	const {
		loading: useUpdateOperationLoading,
		request: useUpdateOperationRequest
	} = useUpdateOperationSync(props.match.params.idOperation);

	const {
		data: useResetOperationStateData,
		loading: useResetOperationStateLoading,
		error: useResetOperationStateError,
		status: useResetOperationStateStatus,
		request: useResetOperationStateRequest,
	} = useResetOperationState(props.match.params.idOperation);

	const {
		loading: useGetOperationLoading,
		request: useGetOperationRequest
	} = useGetOperationAsync(props.match.params.idOperation);

	const {
		data: useGetQuestionnairesAnswersData,
		loading: useGetQuestionnairesAnswersLoading,
		error: useGetQuestionnairesAnswersError,
		status: useGetQuestionnairesAnswersStatus,
		request: useGetQuestionnairesAnswersRequest,
	} = useGetQuestionnaireAnswer(props.match.params.idOperation);

	const {
		loading: useUpdateDocumentsClausesLoading,
		request: useUpdateDocumentsClausesRequest,
	} = useUpdateDocumentsClausesSync(props.match.params.idOperation);

	const {
		data: useSaveQuestionnaireAnswerData,
		loading: useSaveQuestionnaireAnswerLoading,
		error: useSaveQuestionnaireAnswerError,
		status: useSaveQuestionnaireAnswerStatus,
		request: useSaveQuestionnaireAnswerRequest,
	} = useSaveQuestionnaireAnswer(props?.match?.params?.idOperation);

	const {
		data: useSendCCGASyncData,
		loading: useSendCCGASyncLoading,
		error: useSendCCGASyncError,
		status: useSendCCGASyncStatus,
		request: useSendCCGASyncRequest
	} = useSendCCGASync(props.match?.params?.idOperation);

	const {
		loading: useSendStampLoading,
		status: useSendStampStatus,
		error: useSendStampError,
		request: useSendStampRequest,
	} = useSendStamp(props?.match?.params?.idOperation)

	const {
		data: useGetReportDataData,
		loading: useGetReportDataLoading,
		error: useGetReportDataError,
		status: useGetReportDataStatus,
		request: useGetReportDataRequest,
	} = useGetReportData(props?.match.params.idOperation);

	const {
		loading: useGetPersonRoleLoading,
		request: useGetPersonRoleRequest,
	} = useGetPersonRole(props?.match.params.idOperation);

	const {
		request: useSavePersonRelationshipsRequest,
		loading: useSavePersonRelationshipsLoading
	} = useSavePersonRelationships();

	useEffect(() => {
		updateIsLoadingStatus(
			useGetPersonRoleLoading ||
			useGetDocumentsLoading ||
			useGetOperationLoading ||
			useResetOperationStateLoading ||
			useGetQuestionnairesAnswersLoading ||
			useUpdateDocumentsClausesLoading ||
			useUpdateOperationLoading ||
			useSaveQuestionnaireAnswerLoading ||
			clausesLoading ||
			useSendCCGASyncLoading ||
			useSendStampLoading ||
			useGetReportDataLoading ||
			useSavePersonRelationshipsLoading
		)
	}, [
		useGetPersonRoleLoading,
		useGetDocumentsLoading,
		useGetOperationLoading,
		useResetOperationStateLoading,
		useGetQuestionnairesAnswersLoading,
		useUpdateDocumentsClausesLoading,
		useUpdateOperationLoading,
		useSaveQuestionnaireAnswerLoading,
		clausesLoading,
		useSendCCGASyncLoading,
		useSendStampLoading,
		useGetReportDataLoading,
		useSavePersonRelationshipsLoading
	]);

	const handleQuestionnaire = async (data) => {
		let questionnaire = [];
		questionnaire = [
			...data.persons,
			...data.operations,
			...data.payments,
			...data.risks
		];

		setQuestionnaire(questionnaire);
	}

	useEffect(() => {
		if (props.match.params.idOperation) {
			useGetOperationRequest(null, { loadLastDocument: true }).then(response => {
				let operationData;
				if (response.status === 200) {
					operationData = response.data?.value;
					setOperation(operationData);
					setIsBound([5, 419, 6, 133, 158, 187, 263, 104, 99, 159, 140, 177, 188, 198, 176, 403].includes(operationData?.idDomainStatus))
					useGetDocumentsRequest(null, { idDomain: 689 });
					useGetReportDataRequest(null, { onlySigners: true });
					useGetQuestionnairesAnswersRequest(null, { idDomainStatus: operationData?.idDomainStatus })
				}
			});
		}
	}, []);

	useEffect(() => {
		if (useGetQuestionnairesAnswersStatus === 200) {
			handleQuestionnaire(useGetQuestionnairesAnswersData?.value);
		}
	}, [useGetQuestionnairesAnswersStatus]);

	useEffect(() => {
		if (useGetReportDataStatus === 200 && useGetDocumentsStatus === 200) {
			setReportData(useGetReportDataData.value);
			setBorrowerName(useGetReportDataData.value.client_name);

			const documents = useGetDocumentsData.value?.map(quoteRequestDocument => ({
				idDocument: quoteRequestDocument.idDocument,
				idDomainDescription: quoteRequestDocument.idDomainDescription,
				idReport: quoteRequestDocument.idReport,
				idOperation: quoteRequestDocument.idOperation,
				reportToken: quoteRequestDocument.reportToken,
				url: quoteRequestDocument.url,
				fileName: quoteRequestDocument.documentMetadata.fileName,
				documentMetadata: quoteRequestDocument.documentMetadata
			})) || [];
			setDocuments(documents);

			let allCertifiedDeliveries = [];
			let allSigners = [];

			if (useGetReportDataData.value.broker_email) {
				allCertifiedDeliveries.push({
					idPerson: useGetReportDataData.value.broker_uuid,
					name: useGetReportDataData.value.broker_name,
					email: useGetReportDataData.value.broker_email,
					partyType: 'Corretor'
				});
			}

			allSigners.push({
				idPerson: useGetReportDataData.value.client_uuid,
				name: useGetReportDataData.value.client_name,
				email: useGetReportDataData.value.contact_email,
				partyType: 'Tomador'
			});

			useGetReportDataData.value.insurer_witnesses?.map(witness => {
				allSigners.push({
					idPerson: witness.uuid,
					name: witness.name,
					email: witness.email,
					partyType: 'Testemunha'
				})
			});

			useGetReportDataData.value.insurer_representants?.map(representant => {
				allSigners.push({
					idPerson: representant.uuid,
					name: representant.name,
					email: representant.email,
					partyType: 'Representante'
				})
			});

			const selectedPartners = documents[0]?.documentMetadata?.partners || [];
			if (useGetReportDataData.value.ccg_type_id !== 7340) {
				useGetReportDataData.value?.partners?.filter(partner => {
					const hasSelected = selectedPartners.find(
						p => p.documentId === partner.cpf_cnpj_partner_unformated && p.selected
					);
					return hasSelected;
				})?.map(partner => {
					allSigners.push({
						idPerson: partner.partner_uuid,
						name: partner.partner_name,
						email: partner.partner_email,
						partyType: 'Sócio'
					})

					if (partner.is_married && !partner.spoused_total_communion_separation) {
						allSigners.push({
							idPerson: partner.spouse_uuid,
							name: partner.spouse_name,
							email: partner.spouse_email,
							partyType: 'Conjuge'
						})
					}
				});
			}

			allSigners = allSigners.filter((tab, index, array) => array.findIndex(tabOnArray => (tabOnArray.idPerson === tab.idPerson)) === index);

			setSigners(allSigners)
			setCertifiedDeliveries(allCertifiedDeliveries)
		}
	}, [useGetReportDataStatus, useGetDocumentsStatus]);

	useEffect(() => {
		if (useSendStampStatus === 200) {
			useSendCCGASyncRequest().then(async () => {
				mc.success('CCG enviado para Assinatura Eletrônica');
				history.push(`/credit-analysis/stamps-status/${props?.match?.params?.idOperation}`);
			}).catch(() => mc.error('Ocorreu um erro durante o envio do ccg'))
		}

		if (useSendStampStatus === 400) {
			useSendStampError.errors?.map(error => {
				if (error.message) mc.error(error.message)
			})
		}
	}, [useSendStampStatus])

	const onSend = (useManualSignature) => {
		useSendStampRequest(
			{
				message: useSendStampRequestMessage,
				subject: `Assinatura Eletrônica - CCG - SOMPO SEGUROS e ${borrowerName}`,
				manualSignature: useManualSignature,
				signers,
				additionalDocuments: documents,
				certifiedDeliveries,
			},
			{
				idBindOperation: props.match.params.idOperation
			}
		);
	}

	return (
		<Layout
			title={"Enviar CCG"}
			subtitle={`${operation?.productName || ""}`}
		>
			<StepNavigation
				stage={2}
				idOperation={props?.match?.params?.idOperation}
				permissions={permissions}
			/>

			<BrokingSummary
				idProduct={props?.match?.params?.idProduct}
				idOperation={props?.match?.params?.idOperation}
				history={history}
				permissions={permissions}
			/>

			<Content>
				<Formik
					validateOnChange={false}
					innerRef={formikRef}
					initialValues={{ calculationList: [], comission: 0, defaultValueCoverageDisabled: 'N/A' }}
					validationSchema={validationSchema.current}
					enableReinitialize={true}
					onSubmit={() => true}
				>
					{({ values, errors, setFieldValue, setFieldError }) => {
						return (
							<Form onKeyDown={(e) => {
								if (e.key === 'Enter') e.preventDefault();
							}}>
								<FileModal documents={documents} />

								<ButtonContainer style={{ padding: '0 10px' }}>
									<Button forth style={{ width: 'auto' }} onClick={() => handleBack()}> &lt; VOLTAR </Button>
									<ButtonContent>
										<HasPermission permission={operation?.idOperation && permissions.REJECT_CCG}>
											<LostCancelButton idQuestion={1725} idOperation={props.match?.params?.idOperation}
												title={'RECUSAR'} />
										</HasPermission>

										<HasPermission permission={permissions?.REGENERATE_CREDIT_ANALYSIS}>
											<Button
												id="btnContinue"
												type="submit"
												onClick={() => {
													history.push(`/credit-analysis/ccg-edit/${props.match.params.idProduct}/${props.match.params.idOperation}`);
												}}
												style={{ marginLeft: 15 }}
												primary
											>
												EDITAR CCG
											</Button>
										</HasPermission>

										<HasPermission permission={!isBound && permissions.SEND_CREDIT_ANALYSIS}>
											<Button
												id="btnContinue"
												type="submit"
												onClick={() => {
													onSend(false)
												}}
												style={{ marginLeft: 15 }}
												primary
											>
												ASSINATURA ELETRÔNICA
											</Button>
										</HasPermission>

										<HasPermission permission={!isBound && permissions.MANUAL_SIGNATURE}>
											<Button
												id="btnContinue"
												type="submit"
												onClick={() => {
													onSend(true)
												}}
												style={{ marginLeft: 15 }}
												primary
											>
												ASSINATURA MANUAL
											</Button>
										</HasPermission>		

										<HasPermission permission={!isBound && permissions.CREATE_ENQUIRY && operation?.operationMetadata?.envelopeExternalId}>
											<Button
												id="btnCreateQuote"
												type="button"
												onClick={() => history.push("/list")}
												style={{ marginLeft: 15 }}
												primary
											>
												CRIAR COTAÇÃO
											</Button>
										</HasPermission>

									</ButtonContent>
								</ButtonContainer>
							</Form>
						)
					}}
				</Formik>
			</Content>
		</Layout>
	)
}
